import React from 'react'
import {Navigation} from '../components/Navigation'
import {Placeholder, Label, Table, Button, Icon, Card, Transition, Loader} from 'semantic-ui-react'
import { useSelector } from 'react-redux'
import { useFirestore, useFirestoreConnect } from 'react-redux-firebase'
import {Route} from '../components/Router.js'
import { Home } from '../components/mobileapp';

export default function Mobileapp() {
  return (
    <Navigation title="App" icon="mobile" menu={
        [
            /*{
                caption: 'Home',
                icon: 'dashboard',
                active: true
            },*/
            {
                caption: 'Statische Dateien',
                icon: 'file', 
                entries: [
                    {
                        icon: 'file',
                        caption: 'Verwalten',
                        href: '/canvas/events/'
                    },
                    {
                        icon: 'share alt',
                        caption: 'Bereitstellen',
                        href: '/canvas/structure/'
                    }
                ]
            }
        ]
    }>
        <Route path="/app/home*" exact={true} component={Home} />
    </Navigation>
  )
}